import { Component, OnInit, Input, Output, EventEmitter, NgZone, OnDestroy } from "@angular/core";
import { ITCIApplication, TCI_APP_FEATURE_TYPE } from "@tci/common";
import { NgAppListHeaderService } from "./ng-app-list-header.service";
import { setTimeoutInZone } from "../../ng-shared/ng-util/tools";
import { NgAppChangeNotificationService } from "../../ng-shared/ng-services/ng-app-change-notification.service";
import { Subscription } from "rxjs";
import { NgAppFeatureToggleService } from "../../ng-shared/ng-services/ng-app-feature-toggle.service";

@Component({
    selector: "ng-app-list-header",
    templateUrl: "./ng-app-list-header.component.html",
    styleUrls: ["./ng-app-list-header.component.less"]
})
export class NgAppListHeaderComponent implements OnInit, OnDestroy {
    @Input() apps: ITCIApplication[] = [];
    @Output() isInit: EventEmitter<NgAppListHeaderComponent> = new EventEmitter();
    animateRefeshIcon = false;
    subscription: Subscription[] = [];
    appStatusFilterEnabled = false;

    constructor(
        private ngZone: NgZone,
        private metricsService: NgAppListHeaderService,
        private appRefreshNotifSvc: NgAppChangeNotificationService,
        private featureToggleService: NgAppFeatureToggleService
    ) { }

    ngOnInit(): void {
        this.isInit.emit(this);
        this.subscription.push(
            this.featureToggleService.getAppFeatures()
                .subscribe(res => this.appStatusFilterEnabled = res[TCI_APP_FEATURE_TYPE.APP_STATUS_FILTER].enabled
            ),
            this.appRefreshNotifSvc.getRefreshSubject()
                /**
                 * Reason: Manual delay of 1 second as updated metrics data is not available right away after app delete.
                 * Impact: Dashboard will be out of sync with left side status filter after app delete and user will have to
                 * manually refresh the dashboard.
                 */
                 .delay(1000)
                .subscribe(res => {
                    /**
                     * Adding status feature enable check to avoid any side effects from app change
                     * events incase feature is in disabled state.
                     */
                    if (this.appStatusFilterEnabled) {
                        this.refresh();
                    }
                })
        );
    }

    refresh() {
        this.metricsService.setAppsCollection(this.apps); // Pass the applications to the service to make calculations

        this.animateRefeshIcon = true;
        const cb = () => {
            this.animateRefeshIcon = false;
        };
        setTimeoutInZone(this.ngZone, cb, 2000);
    }

    ngOnDestroy() {
        this.subscription.forEach(sub => sub.unsubscribe());
    }
}
